import {createBrowserClient} from '@supabase/ssr'
import {Database} from './tables.generated'
import {env} from '../env'

export const sb = createBrowserClient<Database>(
  env.NEXT_PUBLIC_SUPABASE_URL,
  env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? 'xxx',
  env.NEXT_PUBLIC_SUPABASE_STORAGE_KEY ? {auth: {storageKey: env.NEXT_PUBLIC_SUPABASE_STORAGE_KEY}} : {}
)

export type Sb = typeof sb
